module.exports = __webpack_public_path__ + "static/media/quiz-card-thumbnail.e19ba773.webp";